import type {ChannelExpandedCommon} from '../../../../../api/channel';
import type {StrategyByType} from './types';

import {currentUserStore} from '../../../../../api/user';

export class ChannelDefaultStrategy implements StrategyByType {
  getAvatar(channel: ChannelExpandedCommon) {
    const members = channel.members.filter(
      user => user?._id !== currentUserStore.user?._id,
    );

    return members.length === 1 ? members[0]?.avatar || null : null;
  }

  getClientName(_channel: ChannelExpandedCommon) {
    return null;
  }

  getClientSource(_channel: ChannelExpandedCommon) {
    return null;
  }

  getDescription(_channel: ChannelExpandedCommon) {
    return '';
  }

  getIsArchived(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsCorporate(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsEnded(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsIndividual(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsNewClient(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsOneToOne(channel: ChannelExpandedCommon) {
    return channel.user_ids.length === 2;
  }

  getIsStarted(_channel: ChannelExpandedCommon) {
    return false;
  }

  getTitle(channel: ChannelExpandedCommon) {
    return channel.members
      .filter(user => user?._id !== currentUserStore.user?._id)
      .map(user =>
        user?.deleted ? 'Deleted user' : user?.name || 'User not found',
      )
      .join(', ');
  }

  getUserIsFrozen(_channel: ChannelExpandedCommon, _isUserCoach: boolean) {
    return false;
  }
}
